import script from "./CommentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommentModal.vue?vue&type=style&index=0&id=46cf5fb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cf5fb8"]])

export default __exports__